var chartinfo = [
    

    {
        id: 1,
        title: "Average prices",
        url: "public/DWAP.png"
    }, 
  
    {
        id: 2,
        title: "Demand and prices by time of day",
        url: "public/IntradayPrice.png"
    }, 

    {
        id: 3,
        title: "Generation mix",
        url: "public/GenMix.png"
    }, 

    {
        id: 4,
        title: "Generation mix by time of day",
        url: "public/GenMixDay.png"
    }, 

    {
        id: 5,
        title: "Energy and demand",
        url: "public/MonthlyEnergy.png"
    }, 

    {
        id: 6,
        title: "Electric Storage Resource operating strategy",
        url: "public/ESROperatingStrategy.png"
    }, 

    {
        id: 7,
        title: "Demand and price duration curves",
        url: "public/Duration.png"
    }, 

    {
        id: 8,
        title: "Essential system service prices",
        url: "public/ESSprices.png"
    }, 

    {
        id: 9,
        title: "Carbon emissions",
        url: "public/Carbonhistory.png"
    }, 
]



export default chartinfo